import { CSSProperties, useRef, useState } from 'react';
import { useUpdateEffect, useWindowSize } from 'react-use';

const useTabSwitch = (tabItemClassName: string) => {
  const tabContainerRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState<number>();
  const [currentTabStyle, setCurrentTabStyle] = useState<CSSProperties>({});
  const { width } = useWindowSize();

  useUpdateEffect(() => {
    if (tabContainerRef.current) {
      const containerStyle = tabContainerRef.current.getBoundingClientRect();
      const tabs = tabContainerRef.current.querySelectorAll(`.${tabItemClassName}`);
      const currentTabStyle = tabs[currentIndex || 0].getBoundingClientRect();
      setCurrentTabStyle({
        width: currentTabStyle.width,
        height: currentTabStyle.height,
        left: currentTabStyle.left - containerStyle.left,
        transition: currentTabStyle?.width ? 'left 300ms ease-in-out' : '',
      });
    }
  }, [currentIndex, width]);

  return { currentTabStyle, tabContainerRef, currentIndex, setCurrentIndex };
};

export default useTabSwitch;
